import { useEffect, useState } from 'react'
import { apiGet } from '../admin/primitives.js'

/**
 * ÉTAT CANONIQUE DES INTÉGRATIONS (IA V2) — UN résolveur, servi par
 * /api/v1/settings/integrations/catalog, consommé par TOUTES les surfaces
 * (Réglages → Intégrations, Communication → Intégrations, hubs). Le même
 * connecteur ne peut plus afficher deux états différents (§93, §101).
 */

export interface IntegrationEntry {
  id: string
  name: string
  family: string
  provider: string
  description: string
  status: string
  status_label: string
  status_detail: string | null
  last_sync_at: string | null
  syncs: boolean
  capabilities: { label: string; active: boolean; detail?: string | null }[]
  config_route: string | null
  business_route: string | null
  kind: string
  contract_id: string | null
  contract_version: string | null
  managed: boolean
  summary: string | null
  /** Âge de la clé d'accès — seulement pour les intégrations qui s'ouvrent
   *  par une clé remplaçable depuis leur page (15/10/2026). */
  cle?: {
    configuree: boolean
    rotation: { etat: 'INCONNU' | 'OK' | 'A_PREVOIR' | 'EN_RETARD'; age_jours: number | null; conseil: string }
    /** Date d'enregistrement : « aujourd'hui / hier » se lit au calendrier de Paris. */
    enregistree_le?: string | null
  } | null
}

export function useIntegrationCatalog(): IntegrationEntry[] | null {
  const [data, setData] = useState<IntegrationEntry[] | null>(null)
  useEffect(() => {
    void apiGet<{ integrations?: IntegrationEntry[] }>('/api/v1/settings/integrations/catalog')
      .then((j) => setData(j.integrations ?? []))
      .catch(() => setData([]))
  }, [])
  return data
}

const PILL_CLASS: Record<string, string> = {
  OPERATIONNEL: 'lc-pill--ok',
  PARTIEL: 'lc-pill--warning',
  ACTION_REQUISE: 'lc-pill--warning',
  DEGRADE: 'lc-pill--warning',
  EN_ERREUR: 'lc-pill--error',
  NON_CONFIGURE: 'lc-pill--idle',
  A_INTEGRER: 'lc-pill--idle',
}

/** Le badge d'état commun — même pastille partout (§101, §162). */
export function IntegrationStatusPill({ status, label }: { status: string; label: string }) {
  return (
    <span className={`lc-pill ${PILL_CLASS[status] ?? 'lc-pill--idle'}`}>
      {status === 'OPERATIONNEL' ? <span className="lc-dot lc-dot--ok lc-dot--live" aria-hidden="true" /> : null}
      {label}
    </span>
  )
}
